import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function EditorialSection() {
  const { ref: textRef, isVisible: textVisible } = useScrollAnimation<HTMLDivElement>();
  const { ref: imgRef, isVisible: imgVisible } = useScrollAnimation<HTMLDivElement>({ threshold: 0.1 });

  return (
    <section id="editorial" className="bg-[#F5F1EA] py-20 md:py-40">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-20 items-center">
          {/* Left – Text */}
          <div
            ref={textRef}
            className={`transition-all duration-1000 ${
              textVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"
            }`}
          >
            <p
              className="text-[#B76E79] text-[11px] uppercase tracking-[4px] mb-6 sm:mb-8"
              style={{ fontFamily: "Inter, sans-serif" }}
            >
              Our Philosophy
            </p>
            <h2
              className="text-[#6B4423] text-3xl sm:text-4xl md:text-5xl leading-tight mb-8 sm:mb-10"
              style={{ fontFamily: "Playfair Display, serif", fontWeight: 500 }}
            >
              Crafted to Be Unique
            </h2>
            <div
              className="space-y-5 sm:space-y-6 text-[#7A6F5D] text-base sm:text-lg leading-relaxed"
              style={{ fontFamily: "Inter, sans-serif", fontWeight: 300 }}
            >
              <p>
                Each piece of Rustic Copper begins as raw material and becomes a
                statement of identity.
              </p>
              <p className="italic text-[#6B4423]/80" style={{ fontFamily: "Playfair Display, serif" }}>
                No mass production. No repetition.
              </p>
              <p>
                Only handcrafted jewelry designed with intention — for those who
                understand that true luxury is not purchased, it is experienced.
              </p>
            </div>

            {/* Decorative line */}
            <div className="flex items-center gap-5 mt-10 sm:mt-12">
              <div className="w-16 h-px bg-[#B76E79]/50" />
              <p
                className="text-[#B76E79] text-[11px] uppercase tracking-[3px]"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Est. 2018
              </p>
            </div>
          </div>

          {/* Right – Image */}
          <div
            ref={imgRef}
            className={`transition-all duration-1000 delay-200 ${
              imgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"
            }`}
          >
            <div className="relative w-full h-[380px] sm:h-[480px] lg:h-[600px] overflow-hidden rounded-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/edited_7228d87fcc94d26d44be8c2a4b468347_06caef64.jpg"
                alt="Artisan crafting copper jewelry"
                className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-700"
              />
              {/* Subtle copper overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-[#6B4423]/20 to-transparent" />
            </div>

            {/* Floating stat card */}
            <div className="mt-4 sm:mt-[-60px] mr-0 ml-auto w-48 sm:w-56 bg-[#FAF8F3] p-5 sm:p-6 relative z-10 rounded-lg">
              <p
                className="text-[#6B4423] text-2xl sm:text-3xl mb-1"
                style={{ fontFamily: "Cinzel, serif", fontWeight: 400 }}
              >
                1,200+
              </p>
              <p
                className="text-[#7A6F5D] text-xs uppercase tracking-[2px]"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                Unique pieces crafted
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
